import { render, staticRenderFns } from "./MpcForms.vue?vue&type=template&id=1859cd25&"
import script from "./MpcForms.vue?vue&type=script&lang=js&"
export * from "./MpcForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports